<div class="page-wrapper" [ngClass]="isMobile === true ? 'page-wrapper-mobile' : ''">
  <colimo-page-header [heading]="'sidenav.credits'"> </colimo-page-header>
  <section>
    <b>Surventis GmbH</b>
    <br>Legal Headquarters: 48165 Muenster, Germany
    <br>Registered at the Local Court in Münster

    <p></p>
    <b>Company Registration No.:</b>
    <br>HRB 5144

    <p></p>
    <b>Management Board:</b>
    <br>Markus Dinslacken
    <br>Michael Pontzen

    <p></p>
    <b>Supervisory Board:</b>
    <br>Edgar Winzenhöler, Vice Chairman

    <p></p>
    <b>Sales Tax Identification Number:</b>
    <br>DE811122710
  </section>
</div>
